// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__17Shk","productName":"Table_productName__1_SV0"};